import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
const useStyles = makeStyles({
  main: {
    width: "100%",
    height: "15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  ringPoint: {
    color: "#4CAF50",
    fontSize: "17px",
    marginTop: "5px",
  },
  progressMain: {
    boxShadow: "0px 0px 1px 1px #ccc",
    height: "15px",
    width: "80%",
    background: "white",
    borderRadius: "5px",
  },
});

const PasswordStrengthMeter = (props) => {
  let classes = useStyles();
  const [style, setStyle] = React.useState({
    borderRadius: "5px",
    height: "15px",
    width: "0%",
    background: "#cf3737",
  });

  React.useEffect(() => {
    if (props.password) {
      let strength = 0;
      if (props.password.length > 7) strength += 1;
      if (
        props.password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/) &&
        props.password.length > 3
      )
        strength += 1;
      if (
        props.password.match(/([a-zA-Z])/) &&
        props.password.match(/([0-9])/) &&
        props.password.length > 3
      )
        strength += 1;
      if (
        props.password.match(/([!,%,&,@,#,$,^,*,?,_,~])/) &&
        props.password.length > 3
      )
        strength += 1;
      if (strength < 2) {
        props.handlePasswordSterngthText({ text: "Weak", color: "#cf3737" });
        setStyle({
          ...style,
          width: "25%",
          background: "#cf3737",
        });
      } else if (strength == 2) {
        props.handlePasswordSterngthText({
          text: "Pretty Good",
          color: "#cf9137",
        });
        setStyle({
          ...style,
          width: "75%",
          background: "#cf9137",
        });
      } else if (strength == 4) {
        props.handlePasswordSterngthText({
          text: "Strong !",
          color: "#37cf41",
        });
        setStyle({
          ...style,
          width: "100%",
          background: "#4CAF50",
        });
      }
    } else {
      props.handlePasswordSterngthText({ text: "", color: "" });
      setStyle({
        ...style,
        width: "0%",
        background: "#4CAF50",
      });
    }
  }, [props.password]);

  return (
    <div className={classes.main}>
      <div>
        {style.width == "100%" && (
          <CheckCircleIcon className={classes.ringPoint} />
        )}
      </div>
      <div className={classes.progressMain}>
        <div
          style={{
            height: "15px",
            borderRadius: "5px",
            width: `${style.width}`,
            background: `${style.background}`,
          }}
        ></div>
      </div>
    </div>
  );
};
export default React.memo(PasswordStrengthMeter);
